import { Link, useMatch, useResolvedPath, useNavigate, useLocation } from "react-router-dom"
import { BsTools, BsFillGeoAltFill } from "react-icons/bs"
import { ImUser } from "react-icons/im"
import { GiExitDoor } from "react-icons/gi"
import { useState, useEffect, useRef } from "react";
import { clearLocalStorage } from '../functions/LoginCheck';

export default function Navbar()
{
    const opacityRef = useRef(0);
    const fadeTimeout = useRef(null);
    const fadeInterval = useRef(null);
    const lastScrollY = useRef(window.scrollY);
    const lastTime = useRef(Date.now());

    const siteTitle = process.env.REACT_APP_WEB_NAME;
    const location = useLocation();
    const navigate = useNavigate();
    const [navOpen, setNavOpen] = useState(false);
    const [shadowOpacity, setShadowOpacity] = useState(0);
    const [LoginInStatus, setLoginInStatus] = useState(false);

    useEffect(() => {
        if (location.pathname !== "/user-login" && location.pathname !== "/signup")
        {
            if (localStorage.getItem("lh_api_access_token") === "" || localStorage.getItem("lh_api_access_token") === null)
            {
                setLoginInStatus(false);
            }
            else
            {
                setLoginInStatus(true);
            }
        }
        else
        {
            setLoginInStatus(false);
        }
    },[location])

    const updateOpacity = (targetOpacity) => {
        if (targetOpacity !== opacityRef.current) {
            opacityRef.current = targetOpacity;
            setShadowOpacity(targetOpacity);
        }
    };

    const startFadeOut = () => {
        clearInterval(fadeInterval.current);
        fadeInterval.current = setInterval(() => {
            setShadowOpacity((prev) => {
            const next = prev * 0.1;
            if (next <= 0.05) {
                clearInterval(fadeInterval.current);
                opacityRef.current = 0;
                return 0;
            }
            opacityRef.current = next;
            return next;
            });
        }, 16); // ~60fps
    };
    
    useEffect(() => {
        const handleScroll = () => {
            const now = Date.now();
            const newY = window.scrollY;
            const deltaY = Math.abs(newY - lastScrollY.current);
            const deltaTime = now - lastTime.current;

            const speed = deltaTime > 0 ? deltaY / deltaTime : 0;
            const maxSpeed = 2;
            const normalized = Math.min(speed / maxSpeed, 1);
            const targetOpacity = Math.max(0.05, normalized * 0.4);

            updateOpacity(targetOpacity);

            lastScrollY.current = newY;
            lastTime.current = now;

            // Reset fade timer
            clearTimeout(fadeTimeout.current);
            clearInterval(fadeInterval.current); // stop any ongoing fade
            fadeTimeout.current = setTimeout(startFadeOut, 300); // wait before fading
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
            clearTimeout(fadeTimeout.current);
            clearInterval(fadeInterval.current);
        };
    }, []);
      
    return (
    <nav className = "nav"
        style={{
            boxShadow: `0 2px 6px rgba(0, 0, 0, ${shadowOpacity.toFixed(2)})`,
        }}
    >
        <div className="nav-container">
            <Link to="/" className = "site-title" onClick={() => setNavOpen(false)}>
                {siteTitle}
            </Link>
            <div className={`toggle-button ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(!navOpen)}>
                <span className="bar"></span>
                <span className="bar"></span>
                <span className="bar"></span>
            </div>
        </div>
        <div className = "nav-expanded" style={{
            top: navOpen ? "3rem" : "-500%",
            transitionDelay: navOpen ? "0s": "0s",
        }}>
            <ul>
                <CustomLink to="/about" onClick={() => setNavOpen(false)}>
                    <div className="navLinks">
                        <BsFillGeoAltFill/>
                        <span>About</span>
                    </div>
                </CustomLink>
                {LoginInStatus&&(
                    <CustomLink to="/tools" onClick={() => setNavOpen(false)}>
                        <div className="navLinks">
                            <BsTools/>
                            <span>Tools</span>
                        </div>
                    </CustomLink>
                )}
                {LoginInStatus&&(
                    <CustomLink to="/user-profile" onClick={() => {setNavOpen(false)}}>
                        <div className="navLinks">
                            <ImUser/>
                            <span>Profile</span>
                        </div>
                    </CustomLink>
                )}
                {LoginInStatus&&(
                    <CustomLink to="/user-login" onClick={() => {
                        setNavOpen(false);
                        clearLocalStorage();
                        navigate("/user-login", { replace: true });
                        }}>
                        <div className="navLinks">
                            <GiExitDoor/>
                            <span>Logout</span>
                        </div>
                    </CustomLink>
                )}
            </ul>
        </div>
    </nav>
    );
}

function CustomLink({to, children, ...props})
{
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch( {path: resolvedPath.pathname, end: true})
    return (
        <li className={isActive ? "active" : ""}>
            <Link to = {to} {...props}>{children}</Link>
        </li>
    )
}